import SummaryStats from "@/components/SummaryStats";
import SpendingPieChart from "@/components/SpendingPieChart";
import SpendingBarChart from "@/components/SpendingBarChart";
import TransactionsTable from "@/components/TransactionsTable";
import { DashboardProvider } from "@/components/DashboardContext";
import { Link } from "react-router-dom";
import { AnonymizeProvider, useAnonymize } from "@/components/AnonymizeContext";
import { Switch } from "@/components/ui/switch";

function AnonymizeToggle() {
  const { anonymize, setAnonymize } = useAnonymize();
  return (
    <div className="absolute top-2 right-2 flex items-center gap-2 z-30">
      <Switch id="anonymize" checked={anonymize} onCheckedChange={setAnonymize} />
      <label htmlFor="anonymize" className="text-sm text-gray-700 select-none cursor-pointer">
        Anonymize data
      </label>
    </div>
  );
}

const Index = () => {
  return (
    <AnonymizeProvider>
      <DashboardProvider range="month">
        <div className="min-h-screen bg-[#F1F0FB] px-2 pb-8 relative">
          <AnonymizeToggle />
          <header className="py-8 mb-4 text-center">
            <h1 className="text-3xl sm:text-4xl font-extrabold text-primary tracking-tight mb-2 drop-shadow">
              Spend Sense - Personal Finance Dashboard
            </h1>
            <p className="text-lg text-gray-500">Visualize your spending, track your habits, and gain insights with clarity.</p>
            <Link to="/year-to-date" className="inline-block mt-5 text-primary underline font-medium">
              View Year to Date Dashboard &rarr;
            </Link>
          </header>
          <div className="max-w-6xl mx-auto">
            <SummaryStats />
            <div className="grid md:grid-cols-2 gap-6">
              <SpendingPieChart />
              <SpendingBarChart />
            </div>
            <TransactionsTable />
          </div>
        </div>
      </DashboardProvider>
    </AnonymizeProvider>
  );
};

export default Index;
